import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { WithIsHome, WithTeam } from '~/core/styleTypes';

type WithIsCalendarView = { $isCalendarView?: boolean };

export const TeamMatchupContainer = styled.div<WithIsCalendarView>`
    ${BaseStyle.Mixins.gaps.extraSmall}
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: ${({ theme }) => theme.Text.secondary};
    cursor: initial;

    ${({ $isCalendarView }) =>
        !$isCalendarView &&
        css`
            padding: 10px;
            margin-bottom: 10px;
            margin-left: 6px;
            margin-right: 6px;

            ${BaseStyle.Mixins.screenSizes.medium} {
                margin-bottom: 0;
                margin-left: 8px;
                margin-right: 8px;
            }

            ${BaseStyle.Mixins.screenSizes.large} {
                margin-left: 11px;
                margin-right: 11px;
                margin-top: -14px;
            }
        `}
`;

export const TeamMatchup = styled.div<WithIsCalendarView>`
    display: flex;
    width: ${({ $isCalendarView }) => ($isCalendarView ? '100%' : '136px')};
    height: ${({ $isCalendarView }) => ($isCalendarView ? '30px' : '36px')};
    color: ${({ theme }) => theme.Surface.secondary};
    justify-content: center;
    align-items: center;
    margin-left: ${({ $isCalendarView }) => ($isCalendarView ? '-4px' : '-5px')};
    margin-bottom: ${({ $isCalendarView }) => ($isCalendarView ? '-4px' : '0')};

    ${BaseStyle.Mixins.screenSizes.large} {
        width: 136px;
        height: 36px;
        margin-left: ${({ $isCalendarView }) => ($isCalendarView ? '0' : '-1px')};
        margin-bottom: 0;
    }
`;

export const TeamContainer = styled.div<WithIsCalendarView & WithIsHome & WithTeam>`
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: ${({ $isCalendarView, $isHome }) => ($isCalendarView ? ($isHome ? 'left' : 'right') : 'center')};
    margin-left: ${({ $isCalendarView, $isHome }) => (!$isCalendarView ? ($isHome ? '-14px' : '-11px') : '0')};

    svg {
        fill: none;
        width: ${({ $isCalendarView }) => ($isCalendarView ? '50px' : '71px')};
        height: ${({ $isCalendarView }) => ($isCalendarView ? '25px' : '36px')};
    }

    path {
        fill: ${({ theme, $teamAbbrev }) =>
            $teamAbbrev && theme.Team[$teamAbbrev] ? theme.Team[$teamAbbrev].primary : 'none'};
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        margin-right: ${({ $isHome }) => ($isHome ? 0 : '-3px')};
        margin-left: ${({ $isHome }) => ($isHome ? '-3px' : 0)};
        justify-content: left;

        svg {
            width: 71px;
            height: 36px;
        }
    }
`;

export const TeamLogoContainer = styled.div<WithIsCalendarView>`
    margin-left: ${({ $isCalendarView }) => ($isCalendarView ? '-40px' : '-55px')};
    margin-top: ${({ $isCalendarView }) => ($isCalendarView ? '2px' : '5px')};
    width: 36px;
    height: 24px;

    ${({ $isCalendarView }) =>
        $isCalendarView
            ? css`
                  .team-logo {
                      width: 30px;
                      height: 20px;
                  }
              `
            : css`
                  .team-logo {
                      width: 36px;
                      height: 24px;
                  }
              `}

    ${BaseStyle.Mixins.screenSizes.large} {
        margin-left: -55px;
        margin-top: 5px;

        .team-logo {
            width: 36px;
            height: 24px;
        }
    }
`;

export const EventName = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['10b']}
    display: flex;
    justify-content: center;
`;
